import styled from 'styled-components';
import { Colors, FontSize, Spacing } from '../../assets/GlobalStyle/Variables';

export const ProtocolListContainer = styled.div`
  padding: 1.5rem 2rem;
  background: linear-gradient(to bottom, #f8f5fa 0%, #ffffff 100%);
  min-height: calc(100vh - 68px);
`;

export const StyledPageTitle = styled.div`
  background: linear-gradient(135deg, ${Colors.primary} 0%, ${Colors.secondary} 100%);
  border-radius: 12px;
  padding: 1.5rem 2rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  margin-bottom: 1.5rem;

  h1 {
    color: ${Colors.white};
    font-size: ${FontSize.title};
    font-weight: 600;
    margin: 0;
    letter-spacing: -0.3px;
  }
`;

export const TableCard = styled.div`
  background: ${Colors.white};
  border-radius: 16px;
  padding: 1.5rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  margin-top: 1.5rem;
  overflow: hidden;
`;

export const StyledTable = styled.table`
  width: 100%;
  font-size: 14px;
`;

export const StyledTableHead = styled.thead`
  background-color: ${Colors.lightBackground};
  border: 1px solid #cde0ee;
  height: 50px;
  vertical-align: top;

  th {
    border-right: 1px solid ${Colors.lightGrey};
    padding: ${Spacing(4)};

    div {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;

      span {
        cursor: pointer;
      }
    }
  }
`;

export const StyledTableBody = styled.tbody`
  border-left: 1px solid ${Colors.lightGrey};

  tr {
    height: 40px;
    border-bottom: 1px solid ${Colors.lightGrey};

    &.locked {
      background-color: ${Colors.disabled};
    }
  }

  td {
    border-right: 1px solid ${Colors.lightGrey};
    padding: ${Spacing(1)} ${Spacing(4)};

    &.clickable {
      cursor: pointer;
      transition: background-color 0.2s ease;

      &:hover {
        background-color: ${Colors.lightBackground};
      }
    }

    &:nth-child(1) {
      width: 10%;
    }
    &:nth-child(2) {
      width: 6%;
      text-align: center;
    }
    &:nth-child(3) {
      width: 10%;
    }
    &:nth-child(4) {
      width: 8%;
    }
    &:nth-child(5) {
      text-align: center;
      width: 6%;
    }
    &:nth-child(6) {
      text-align: center;
      width: 6%;
    }
    &:nth-child(7) {
      width: 5%;
    }
    &:nth-child(8) {
      text-align: center;
      width: 4%;
    }
    &:nth-child(9) {
      text-align: center;
      width: 7%;
    }
    &:nth-child(10) {
      text-align: center;
      width: 8%;
    }
    &:nth-child(11) {
      text-align: center;
      width: 6%;
    }
    &:nth-child(12) {
      text-align: center;
      width: 4%;
    }
    &:nth-child(13) {
      text-align: center;
      width: 4%;
    }
    &:nth-child(14) {
      width: 8%;
    }
    &:nth-child(15) {
      width: 8%;
    }

    button {
      font-size: 14px;
      padding: 0 4px;
      line-height: 30px;
    }
  }
`;

export const StyledProtocolNumberCell = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
`;

export const StyledLockIcon = styled.span`
  font-size: 12px;
`;

export const StyledWarningIcon = styled.span`
  font-size: 12px;
`;

export const PaginationWrapper = styled.div`
  margin-top: 2rem;
`;
